import { useAuth } from '../context/AuthContext';
export function useApi() {
  const { token, logout } = useAuth();
  async function call(method, path, body) {
    const opts = { method, headers: { 'Content-Type': 'application/json', 'x-admin-key': token || '' } };
    if (body) opts.body = JSON.stringify(body);
    const res  = await fetch('/api/admin' + path, opts);
    const data = await res.json();
    if (data.error === 'Token invalid hai') { logout(); return; }
    return data;
  }
  return {
    get:  (path)       => call('GET',    path),
    post: (path, body) => call('POST',   path, body),
    put:  (path, body) => call('PUT',    path, body),
    del:  (path)       => call('DELETE', path),
  };
}